import { useEffect, useRef, useState } from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import { platform } from "./react";
import { exampleNamed } from "../../lib/examples/list";
import styles from "../market/market.module.css";

// Trying an example site (/examples): an address with ?example=<id> runs that example's plugin
// in this tab, exactly as a site with it in truechops.config.js would, until you leave. Nobody else
// sees it. All it keeps is what an example is for keeping: a set list's songs, a chain's bars.
const KEY = "truechops.example";
const PLUGINS = {
  "band-director": () => import("../../../plugins/examples/band-director"),
  drumline: () => import("../../../plugins/examples/drumline"),
  "piano-teacher": () => import("../../../plugins/examples/piano-teacher"),
  publisher: () => import("../../../plugins/examples/publisher"),
  worship: () => import("../../../plugins/examples/worship"),
  therapist: () => import("../../../plugins/examples/therapist"),
  composer: () => import("../../../plugins/examples/composer"),
  "patch-garden": () => import("../../../plugins/examples/patch-garden"),
  "step-team": () => import("../../../plugins/examples/step-team"),
  "heart-sounds": () => import("../../../plugins/examples/heart-sounds"),
  rhythmle: () => import("../../../plugins/examples/rhythmle"),
  "meter-machine": () => import("../../../plugins/examples/meter-machine"),
  "exquisite-corpse": () => import("../../../plugins/examples/exquisite-corpse"),
  "road-trip": () => import("../../../plugins/examples/road-trip"),
};
const asked = () => new URLSearchParams(window.location.search).get("example");
// Whether this tab is showing an example, or is about to.
export function previewingExample() {
  if (typeof window === "undefined") return false;
  try { return Boolean(PLUGINS[asked()] || PLUGINS[sessionStorage.getItem(KEY)]); } catch { return false; }
}

export default function ExamplePreview() {
  const router = useRouter(), [shown, setShown] = useState(null), running = useRef(null);
  useEffect(() => {
    let id = null;
    try {
      // The examples' own pages are the way out.
      if (router.pathname.startsWith("/examples")) { sessionStorage.removeItem(KEY); if (running.current) window.location.reload(); return; }
      if (PLUGINS[asked()]) sessionStorage.setItem(KEY, asked());
      id = sessionStorage.getItem(KEY);
    } catch { return; }
    if (!PLUGINS[id] || running.current === id) return;
    PLUGINS[id]().then(({ default: plugin }) => {
      if (running.current) platform().remove(running.current);
      platform().use(plugin);
      running.current = plugin.id && id;
      // For the examples' browser test: it can say a star was clicked.
      window.__examplePlatform = platform();
      setShown(exampleNamed(id));
    });
  }, [router.asPath, router.pathname]);
  if (!shown) return null;
  return <aside className={styles.exampleBar} aria-label="Example site" data-example-bar={shown.id}>
    <span>Example: <strong>{shown.site}</strong>, a made-up site.</span>
    <Link href={`/examples/${shown.id}`}>How it&apos;s built</Link>
    <Link href="/examples" data-leave-example>Leave</Link>
  </aside>;
}
